/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {StateConfigurationModel} from '../../../../shared/status-timeline/models/state-configuration.model';
import {SettlementStatusEnum} from '../../../models/settlement-status.enum';

export const settlementTimelineHappyPath: {
    pending: StateConfigurationModel;
    accepted: StateConfigurationModel;
    rejected: StateConfigurationModel;
    unknown: StateConfigurationModel;
} = {
    pending: {
        code: SettlementStatusEnum.PENDING,
        name: 'Pending',
        color: null,
        repeatable: false
    },
    accepted: {
        code: SettlementStatusEnum.ACCEPTED,
        color: null
    },
    rejected: {
        code: SettlementStatusEnum.REJECTED,
        color: null
    },
    unknown: {
        code: SettlementStatusEnum.UNKNOWN,
        name: '',
        color: null
    }
};
